<template>
  <div class="public-support-profile">
    <div class="md-card-unspaced public-card rfider-shadow">
      <div
        v-if="item.supportProfileImage || item.supportProfileSecondaryImage"
        class="public-support-profile-secondary-image"
        :style="{
          'background-image': item.supportProfileSecondaryImage
            ? `url(${mixinGetFilePath(
                item.supportProfileSecondaryImage,
                'XL',
              )})`
            : 'none',
        }"
      >
        <div
          v-if="item.supportProfileImage"
          :style="{
            'background-image': item.supportProfileImage
              ? `url(${mixinGetFilePath(
                  item.supportProfileImage,
                  supportProfileImageExtension === 'gif' ? 'O' : 'XL',
                )})`
              : 'none',
          }"
          class="public-support-profile-image"
        ></div>
      </div>
      <md-card-content v-if="hasContent" class="public-card-content">
        <div class="public-card-name" v-if="item.supportProfileName">
          {{ item.supportProfileName }}
        </div>
        <div v-if="item.supportProfilePhone">
          <a :href="`tel:${item.supportProfilePhone}`" target="_blank">
            <img :src="'/img/avatars/avatar-phone.png'" class="avatar-image" />
            {{ item.supportProfilePhone }}
          </a>
        </div>
        <div v-if="item.supportProfileEmail">
          <a :href="`mailto:${item.supportProfileEmail}`" target="_blank">
            <img :src="'/img/avatars/avatar-email.png'" class="avatar-image" />
            {{ item.supportProfileEmail }}
          </a>
        </div>
        <div v-if="item.supportProfileWechatId">
          <span :href="`weixin://dl/chat`" target="_blank">
            <img :src="'/img/avatars/avatar-wechat.png'" class="avatar-image" />
            {{ item.supportProfileWechatId }}
          </span>
        </div>
        <div v-if="item.supportProfileGreeting">
          <div class="ql-editor" v-html="item.supportProfileGreeting"></div>
        </div>
      </md-card-content>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasContent() {
      return (
        this.item &&
        (this.item.supportProfileName ||
          this.item.supportProfilePhone ||
          this.item.supportProfileEmail ||
          this.item.supportProfileWechatId ||
          this.item.supportProfileGreeting)
      );
    },
    supportProfileImageExtension() {
      try {
        return this.item.supportProfileImage.match(
          /\.([0-9a-z]+)(?:[?#]|$)/i,
        )[1];
      } catch (err) {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.public-card {
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}
.public-card-content {
  padding: 15px 20px;
}
.public-card-name {
  font-weight: 600;
  font-size: 20px;
  margin: 20px 0;
}
.public-support-profile-secondary-image {
  position: relative;
  background-size: cover !important;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px 10px 0px 0px;

  &:after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }
}
.public-support-profile-image {
  position: absolute;
  background-size: contain !important;
  background-position: center;
  background-repeat: no-repeat;
  width: 40%;
  top: 50%;
  left: 50%;
  border-radius: 10px;
  z-index: 1;
  transform: translate(-50%, -50%);

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
}
.avatar-image {
  width: 24px;
  height: 24px;
}
</style>
